import React from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import Button from 'components/Buttons/Button'
import ROUTES from 'utils/ROUTES'
import { GlobalErrorMessage } from 'services/connexion-services'
import ScreenContainerSimpleLayoutConnexion from 'layouts/ScreenContainerSimpleLayoutConnexion'

const EmailModifiedFail: React.FC = () => {
  interface StateType {
    reason: string
  }

  const history = useHistory()
  const { t } = useTranslation()
  const { state } = useLocation<StateType>()

  return (
    <ScreenContainerSimpleLayoutConnexion isLogged={false}>
      <div className="email-modified">
        <div className="email-modified_text-container">
          <div className="content">
            {state?.reason === GlobalErrorMessage.UNAVAILABLE_EMAIL ? (
              <>
                <h2 className="title">
                  {t('emailModifiedFail.unavailableEmail.title')}
                </h2>
                <div>
                  <p className="infos">
                    {t('emailModifiedFail.unavailableEmail.info')}
                  </p>
                </div>
              </>
            ) : (
              <>
                <h2 className="title">
                  {t('emailModifiedFail.expiredLink.title')}
                </h2>
                <div>
                  <p className="infos">
                    {t('emailModifiedFail.expiredLink.info')}
                  </p>
                </div>
              </>
            )}
            <Button onClick={() => history.push(ROUTES.ModifyUserEmail)}>
              {t('emailModifiedFail.button')}
            </Button>
          </div>
        </div>
      </div>
    </ScreenContainerSimpleLayoutConnexion>
  )
}

export default EmailModifiedFail
